<script>
import Lock from '../../utils/Lock'
const { VUE_APP_API_HOST } = process.env
const moment = require('moment')

export default {
  data() {
    return {
      user: undefined,
      trial_duration: 8 /* days */
    }
  },
  async created() {
    if(localStorage.user && JSON.parse(localStorage.user))
      this.user = JSON.parse(localStorage.user)
    else 
      await this.fetchUserInfo()
  },
  computed: {
    canHaveTrial() {
      return !!this.user
        && !!this.user._premium
        && !this.user._premium.plan
        && this.user._premium.trial === null
    },

    isUserPremiumActive() {
      return this.user
        && this.user._premium
        && this.user._premium.active
    },

    isUserPartner() {
      return this.user && this.user.partner
    },

    isUserOnTrial() {
      return this.isUserPremiumActive && this.user._premium.trial
        && (new Date(this.user._premium.trial) >= new Date())
    },

    userHasDiscount() {
      return this.isUserPremiumActive && this.user._premium.discount
    },

    getUserPlan() {
      return this.user && this.user._premium && this.user._premium.plan || 0
    },

    
  },
  methods: {
    async fetchUserInfo() {
      // Get user info from API
      const apiUrl = `${VUE_APP_API_HOST}/users/me`
      const token = localStorage.getItem('token') // FIXME use cookie
      const headers = { Authorization: `Bearer ${token}` }
      await this.$http.get(apiUrl, { headers }).then(res => {
        /**
         * {{ _premium: {active : Boolean, trial: Date } }} this.user
         */
        if(res && res.data && res.data.user) {
          this.user = res.data.user
          localStorage.setItem('user', JSON.stringify(res.data.user))
        }
    
      }, err => err)

      return JSON.parse(localStorage.user)
    },

    refreshUserInfos(){
      return this.fetchUserInfo()
    },

    daysRemainingTrial() {
      return this.isUserOnTrial
        ? Math.round(moment.duration(moment(this.user._premium.trial).diff()).asDays())
        : 0
    },

    checkUserPlan(other) {
      return this.getUserPlan === other
    },

    checkUserPlanName(name) {
      console.log('key', name)
      let plans = [
        {name:'free', value:0},
        {name:'starter', value:1},
        {name:'standard', value:2},
        {name:'premium', value:3},
      ]
      let other = plans.find(p => p.name == name).value
      return this.checkUserPlan(other)
    },

    checkUserAnnualPlan() {
      if(this.user && this.user._premium && this.user._premium.is_annual)
        return true
      return false
    },

    checkUserOlderOffer() {
      if(this.user && this.user._premium && this.user._premium.is_old_offer)
        return true
      return false
    },

    checkUserPageAccess(pageId) {
      return this.user 
                && ((this.user.pages_access && this.user.pages_access.length && this.user.pages_access.includes(pageId)) 
                      || !this.user.pages_access || this.user.pages_access.length == 0)
    },

    notifyNotPremium(content='dash.bots.cannot_edit') {
      this.$vs.notify({
        title: this.$t('dash.locked'),
        text: this.$t(content),
        color: '#842993',
      })
    },

    checkLock(lockName) {
      const plan = this.getUserPlan

      switch (lockName) {
        case 'bots_daily':
          // Daily post limit
          return plan !== 0
        case 'source_choice':
          // User can add a limited amount of sources per plan
          return Lock.custom_sources[plan]
        case 'pages':
          if(JSON.parse(localStorage.user).account == '0960a21c-6e71-44c0-aa5e-ba213a647981' || JSON.parse(localStorage.user).account == '7a5cd08d-2ebc-4d46-aaf5-760188603260' || JSON.parse(localStorage.user).account == '09234a32-6431-41f7-973e-5587e2ba9f0f' || JSON.parse(localStorage.user).account == '63fc164e-60da-41a7-9619-0c5fe6561239') {
            // limit to 4 pages on next-plz, Foot01 and Vericel and lyoncapitale accounts
            return this.linked.length >= 4
          }
          else if(JSON.parse(localStorage.user).account == '5345cbda-93fa-4a23-b7c5-f6c634d72f7c') {
            // limit to 5 pages on esportfr account
            return this.linked.length >= 5
          }
          else if(JSON.parse(localStorage.user).account == '450a70c4-4f1a-40c0-b116-a08024e90ed1' || JSON.parse(localStorage.user).account == '886dda37-72b7-466b-a02d-6ed811458ac5') {
            // limit to 15 pages on footmarseille and actupenit accounts
            return this.linked.length >= 15
          }
          else if(['ae993ea1-a5bf-48d6-b151-507b8a258ebd', 'd2e5ed17-eaf3-4ba0-a2ba-9e1f95757776', 'd12717da-7255-4d0d-a77c-417578e016a8'].includes(JSON.parse(localStorage.user).account)) {
            // limit to 5000 pages on postday.io and Matthieu accounts (prod/dev)
            return this.linked.length >= 5000
          }
          else if(['ae86abdb-a77f-4434-a682-87bc265b0da4'].includes(JSON.parse(localStorage.user).account)) {
            // limit to 12 pages on wamiz and saabre account
            return this.linked.length >= 12
          }
          //wmki 
          else if(['da502f9e-c999-4896-baed-4e1c4110409a'].includes(JSON.parse(localStorage.user).account)) {
            // limit to 70 pages on wmki account
            return this.linked.length >= 70
          }
          else {
            // User can have a limited number of pages
            return this.linked.length >= Lock.rs_limit[plan]
          }
        case 'facebook':
        case 'facebook_allowed':
          // Whether the user can use Facebook pages and bots
          return Lock.facebook_pub[plan]
        case 'pinterest':
        case 'pinterest_allowed':
          // Whether the user can use pinterest pages and bots
          if(['988c5cc9-c14c-4664-9bc8-94719b59d958', '5a45251d-a98a-4f29-aab2-c5bf036c13aa'].includes(JSON.parse(localStorage.user).account)) // foot mercatoanglais & Hector Sandrine accounts
            return true
          return Lock.pinterest_pub[plan] || this.havePlanOptions()
        case 'google':
        case 'google_allowed':
          // Whether the user can use pinterest pages and bots
          if(['988c5cc9-c14c-4664-9bc8-94719b59d958', '5a45251d-a98a-4f29-aab2-c5bf036c13aa'].includes(JSON.parse(localStorage.user).account)) // foot mercatoanglais & Hector Sandrine accounts
            return true
          return Lock.google_pub[plan] || this.havePlanOptions()
        case 'twitter':
        case 'twitter_allowed':
          // Whether the user can use Twitter pages and bots
          return Lock.twitter_pub[plan]
        case 'linkedin':
        case 'linkedin_allowed':
          // Whether the user can use LinkedIn pages and bots
          return Lock.linkedin_pub[plan]
        case 'telegram':
        case 'telegram_allowed':
          // Whether the user can use telegram pages and bots
          return Lock.telegram_pub[plan]
        case 'instagram':
        case 'instagram_allowed':
          // Whether the user can use instagram pages and bots
          return Lock.instagram_pub[plan]
        case 'instagram_story':
        case 'instagram_story_allowed':
          // Whether the user can use instagram pages and bots
          return Lock.instagram_stories_pub[plan] || this.checkPlanOptions(['conciergerie'])
        case 'instagram_credentials':
            return Lock.instagram_credentials[plan] || this.checkPlanOptions(['conciergerie'])
        case 'linkedin_credentials':
            return Lock.linkedin_credentials[plan] || this.checkPlanOptions(['conciergerie'])
        case 'conciergerie':
          return plan == 3 || this.checkPlanOptions(['conciergerie'])
        case 'wonderpush':
        case 'wonderpush_allowed':
          // Whether the user can use wonderpush pages and bots
          return Lock.wonderpush_pub[plan]
        case 'oneSignal':
        case 'oneSignal_allowed':
          // Whether the user can use oneSignal pages and bots
          return Lock.oneSignal_pub[plan]
        case 'tiktok':
        case 'tiktok_allowed':
          // Whether the user can use instagram pages and bots
          return Lock.tiktok_pub[plan]
        case 'youtube':
        case 'youtube_allowed':
          // Whether the user can use instagram pages and bots
          return Lock.youtube_pub[plan]
        case 'batch':
        case 'batch_allowed':
          // Whether the user can use batch pages and bots
          return Lock.batch_pub[plan]
        case 'push_notif_pub':
        return Lock.push_notif_pub[plan] || this.havePlanOptions()
        case 'users':
          // How many users can manage an account
          return this.users.length >= Lock.user_limit[plan]
          // if(JSON.parse(localStorage.user).account == 'e480002b-1c62-41e6-968f-c09d365b0741') {
          //   // limit to 50 users on reworld accounts
          //   return this.users.length >= 50
          // }
          // else {
          //   // How many users can manage an account
          //   return this.users.length >= Lock.user_limit[plan]
          // }
        case 'sources':
        // case 'sources_limit':
          if(JSON.parse(localStorage.user).account == '7a5cd08d-2ebc-4d46-aaf5-760188603260' || JSON.parse(localStorage.user).account == '09234a32-6431-41f7-973e-5587e2ba9f0f') {
            // limit to 4 sources on Vericel and lyoncapitale accounts
            return this.sourceList 
              ? this.sourceList.length >= 4
              : this.sources.sourceList.length >= 4
          }
          else if(JSON.parse(localStorage.user).account == '5345cbda-93fa-4a23-b7c5-f6c634d72f7c') {
            // limit to 5 sources on esportfr account
            return this.sourceList 
              ? this.sourceList.length >= 5
              : this.sources.sourceList.length >= 5
          }
          else if(JSON.parse(localStorage.user).account == '450a70c4-4f1a-40c0-b116-a08024e90ed1' || JSON.parse(localStorage.user).account == '886dda37-72b7-466b-a02d-6ed811458ac5') {
            // limit to 15 sources on footmarseille and actupenit accounts
            return this.sourceList 
              ? this.sourceList.length >= 15
              : this.sources.sourceList.length >= 15
          }
          else if(JSON.parse(localStorage.user).account == '988c5cc9-c14c-4664-9bc8-94719b59d958') {
            // limit to 15 sources on mercatofootanglais accounts
            return this.sourceList 
              ? this.sourceList.length >= 50
              : this.sources.sourceList.length >= 50
          }
          else {
            // User can add a limited amount of sources per plan
            return this.sourceList 
              ? this.sourceList.length >= Lock.feed_limit[plan]
              : this.sources.sourceList.length >= Lock.feed_limit[plan]
          }
        case 'sources_limit':
          if(JSON.parse(localStorage.user).account == '7a5cd08d-2ebc-4d46-aaf5-760188603260' || JSON.parse(localStorage.user).account == '09234a32-6431-41f7-973e-5587e2ba9f0f') {
            // limit to 4 sources on Vericel and lyoncapitale accounts
            return 4
          }
          else if(JSON.parse(localStorage.user).account == '5345cbda-93fa-4a23-b7c5-f6c634d72f7c') {
            // limit to 5 sources on esportfr account
            return 5
          }
          else if(JSON.parse(localStorage.user).account == '450a70c4-4f1a-40c0-b116-a08024e90ed1' || JSON.parse(localStorage.user).account == '886dda37-72b7-466b-a02d-6ed811458ac5') {
            // limit to 15 sources on footmarseille and actupenit accounts
            return 15
          }
          else if(JSON.parse(localStorage.user).account == '988c5cc9-c14c-4664-9bc8-94719b59d958') {
            // limit to 50 sources on mercatofootanglais account
            return 50
          }
          else {
            // How many sources can add
            return Lock.feed_limit[plan]
          }
        case 'partner':
          // is partner
          //return this.user && this.user.partner
          return this.isUserPartner
        case 'posts_limit':
          // How many news can post
          return Lock.post_limit[plan]
        case 'planner':
          // Acces to planner section
          return Lock.planner[plan] || this.checkPlanOptions(['reporting', 'conciergerie'])
        case 'moderation':
          // Acces to moderation section
          return Lock.moderation[plan] || this.checkPlanOptions(['reporting', 'conciergerie'])
        case 'reporting':
          // Acces to reporting section
          return Lock.reporting[plan] == true || this.checkPlanOptions(['reporting'])
        case 'instant':
          // Acces to instant posting/parsing
          return Lock.instant[plan] == true
        case 'admin':
            return JSON.parse(localStorage.user).admin
        default:
          console.error(`Locks: using unknown lock name '${lockName}'`)
          break
      }

      return false
    },

    checkPlanOptions(options) {
      return this.user && this.user._premium && this.user._premium.options_plan && options.some(option => this.user._premium.options_plan.includes(option))
    },

    havePlanOptions() {
      return this.user && this.user._premium && this.user._premium.options_plan && this.user._premium.options_plan.length
    },
    
    saveLocale(id, locale) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/users/locale/${id}?lang=${locale}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    getViewerUrl(id) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/get-viewer-login-url?id=${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    updateUserNotifications(type) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/users/update-notifications`, {type}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    goToPlan() {
      this.$router.push('/dash/settings')
    }
  }
}
</script>
